var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "llm-query-container" }, [
    _c("div", { staticClass: "row" }, [
      this.summaryConfig["search focus"]
        ? _c(
            "div",
            { staticClass: "llm-query-ui-container col-md-12" },
            [
              _c("label", { attrs: { for: "searchFocus" } }, [
                _vm._v(_vm._s(this.summaryConfig["search focus"].label)),
              ]),
              this.summaryConfig["search focus"].type == "input"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.searchFocus,
                        expression: "searchFocus",
                      },
                    ],
                    staticClass: "form-control search-focus-input",
                    attrs: { type: "text" },
                    domProps: { value: _vm.searchFocus },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.searchFocus = $event.target.value
                      },
                    },
                  })
                : _vm._e(),
              _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-primary",
                  on: {
                    click: function ($event) {
                      return _vm.queryLLM()
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(
                      !!this.summaryConfig["button label"]
                        ? this.summaryConfig["button label"]
                        : "Generate summary"
                    )
                  ),
                ]
              ),
              _c("research-loading-spinner", {
                attrs: { isLoading: _vm.loading, colorStyle: "color" },
              }),
            ],
            1
          )
        : _vm._e(),
    ]),
    _vm.summary
      ? _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "llm-query-contents-container col-md-12" },
            [
              _c("response-summary", {
                attrs: {
                  summaryContent: _vm.parsedSummary,
                  summaryConfig: _vm.summaryConfig,
                  utils: _vm.utils,
                  sectionConfig: _vm.sectionConfig,
                  dataset: _vm.dataset,
                },
              }),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }